export function parseRate(rate: number) {
	return `${rate.toFixed(1)}TD`
}
